<script>
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import Popover from "@shared/svelte/Components/Popover/Popover.svelte";

  export let smsPhoneNumber;

  let showMessagesInfo = false;
</script>

<span
  class="float-right padding-left--smaller padding-top--smallest padding-bottom--small show--md"
  id="provi-chat-info"
>
  <Popover
    arrow={false}
    placement="bottom-start"
    bind:open={showMessagesInfo}
    stopPropagation={true}
    widthStyle={"280px"}
    overlayColor="rgba(0,0,0,0)"
  >
    <button class="button button--link-flat margin-bottom--smallest" slot="target">
      <Icon className="popover-icon" type="Info" height="15" width="15" />
    </button>
    <div slot="content" class="content padding--small background-white">
      <div class="default-body--bold padding-right--smallest padding-bottom--smallest">
        Provi Chat messages
      </div>
      {#if smsPhoneNumber}
        <div class="default-body--regular padding-bottom--smallest padding-right--smallest">
          Messages to your reps are being sent via your Provi Chat number
        </div>
        <div
          class="phone-number padding-left--smallest padding-top--smallest padding-bottom--smallest"
        >
          {smsPhoneNumber}
        </div>
      {:else}
        <div class="default-body--regular padding-right--smallest">
          Send messages to all your reps from one place
        </div>
      {/if}
      <div
        class="s6 cursor-pointer underline match-link padding-top--smaller padding-bottom--smallest"
      >
        <a href="https://support.provi.com">Need help?</a>
      </div>
    </div>
  </Popover>
</span>
